import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { trackFBEvent } from "@/lib/fbPixel";

const HomeRegisterButton = () => {
  const [showRegisterButton, setShowRegisterButton] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      setShowRegisterButton(scrollPosition < documentHeight - 200);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleRegisterClick = () => {
    trackFBEvent("ViewContent", {
      content_name: "Floating Register Button",
      content_category: "Registration",
    });
  };

  return (
    <>
      <style>{`
        @keyframes smoothGlow {
          0%, 100% {
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
            transform: scale(1);
          }
          50% {
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.35);
            transform: scale(1.03);
          }
        }
      `}</style>

      <Link
        to="/register"
        onClick={handleRegisterClick}
        className={`fixed bottom-6 left-6 z-40 md:hidden flex items-center gap-2 px-5 py-3 bg-gradient-to-r from-primary to-primary/90 text-primary-foreground font-semibold rounded-full shadow-lg hover:shadow-xl transition-all duration-700 ease-in-out hover:scale-105 ${
          showRegisterButton
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-4 pointer-events-none"
        }`}
        style={{
          animation: showRegisterButton ? "smoothGlow 3s ease-in-out infinite" : "none",
        }}
        aria-label="Register as a student"
      >
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          />
        </svg>
        <span className="text-sm">Register Now</span>
      </Link>
    </>
  );
};

export default HomeRegisterButton;
